import * as React from "react"
import { ThemeProvider } from "next-themes"

const THEME_STORAGE_KEY = "tessera-theme"

export function AppThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      storageKey={THEME_STORAGE_KEY}
      disableTransitionOnChange
    >
      {children}
    </ThemeProvider>
  )
}
